// utils/carteleria.js
import toast from "react-hot-toast"; // ← MANTENER
import { client, log } from ".";

export const getCostosHardware = async ({ pais, ano }) => {
  try {
    const { data: negocios, error: err1 } = await client
      .from("negocios_carteleria")
      .select("id")
      .eq("pais", pais)
      .neq("eliminada", true);
    if (err1) throw err1;
    if (!negocios?.length) return [];

    const negocioIds = negocios.map((n) => n.id);

    const { data, error: err2 } = await client
      .from("costos_carteleria_hardware")
      .select("negocio_id, mes, compra_hardware, otros_costos")
      .eq("ano", ano)
      .in("negocio_id", negocioIds);
    if (err2) throw err2;

    return data || [];
  } catch (error) {
    log.error("getCostosHardware", error);
    toast.error("Error cargando costos de hardware");
    throw error;
  }
};

export const upsertCostoHardware = async ({ negocio_id, ano, mes, compra_hardware = 0, otros_costos = 0 }) => {
  try {
    const { data, error } = await client.from("costos_carteleria_hardware").upsert(
      {
        negocio_id: Number(negocio_id),
        ano: Number(ano),
        mes: Number(mes),
        compra_hardware: Number(compra_hardware) || 0,
        otros_costos: Number(otros_costos) || 0,
      },
      { onConflict: "negocio_id,ano,mes" }
    );
    if (error) throw error;
    return data;
  } catch (error) {
    log.error("upsertCostoHardware", error);
    toast.error("Error guardando costo de hardware");
    throw error;
  }
};
